import type jsPDF from "jspdf";

// Only change html2canvas's detached clone; the on-screen report stays unchanged.
export const prepareReportForPdf = (report: HTMLElement): void => {
    report.style.width = "1040px";
    report.style.maxWidth = "none";
    report.style.backgroundColor = "white";
    report.querySelectorAll<HTMLElement>(".box").forEach((box) => {
        box.style.padding = "12px";
        box.style.marginBottom = "12px";
    });
    report.querySelectorAll<HTMLElement>("p.pb-5").forEach((paragraph) => {
        paragraph.style.setProperty("padding-bottom", "12px", "important");
        paragraph.style.setProperty("padding-right", "0", "important");
    });
    const notice = report.querySelector<HTMLElement>("aside[aria-label]");
    if (notice) notice.style.lineHeight = "1.35";
};

// Render results and notice at the same scale so the notice remains smaller.
// Fit both dimensions to keep every pixel inside one A4 page, even for long summaries.
export const addReportToPdf = (pdf: jsPDF, image: string): void => {
    const margin = 10;
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const { width, height } = pdf.getImageProperties(image);
    const scale = Math.min((pageWidth - margin * 2) / width, (pageHeight - margin * 2) / height);
    const renderedWidth = width * scale;
    pdf.addImage(image, "PNG", (pageWidth - renderedWidth) / 2, margin, renderedWidth, height * scale);
};
